import _objectSpread$1 from '@babel/runtime/helpers/objectSpread2';
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var _objectSpread = _objectSpread$1;
const constants = {
  ANDES_BLUE_500: '#3483FA',
  MENU_TYPE: {
    CORRIDORS: 'CORRIDORS',
    MENU: 'MENU'
  },
  BEHAVIOR_TYPE: {
    BOTTOM_SHEET: 'bottom_sheet',
    REDIRECT: 'redirect'
  },
  BLUR_THRESHOLD: 3,
  TYPES: {
    AFFILIATE: 'affiliate',
    SOCIAL: 'social',
    SUPER: 'super',
    SUPER_PARTNER: 'super_partner',
    SELLER: 'seller',
    BRAND: 'brand',
    LANDING: 'landing',
    LANDING_CBT: 'landing_cbt'
  },
  TYPES_ITEM: {
    FOLDER: 'FOLDER'
  },
  DEFAULT_STATE_SNACKBAR: {
    show: false,
    message: '',
    color: 'green'
  },
  TIMERS: {
    SNACKBAR: {
      MEDIUM: 2000
    },
    UPDATE: {
      MEDIUM: 2000
    }
  },
  PREVIEW: 'preview',
  DISABLE_METRICS: 'disable_metrics',
  REMOVE_PREVIEW_PARAM: 'remove-preview-param',
  CLIENTS: {
    HOME: 'HOME',
    SEARCH: 'SEARCH'
  },
  THEMES: {
    LANDING_CBT: 'landing_cbt'
  }
};
const MAX_L2 = {
  [constants.TYPES.SELLER]: {
    mobile: 8,
    desktop: 4
  },
  [constants.TYPES.BRAND]: {
    mobile: 8,
    desktop: 4
  }
};
const HIDDEN_NODE_HEADER = [constants.TYPES.BRAND, constants.TYPES.SELLER];
const BUTTON_MOBILE_FOLLOWER = [constants.TYPES.SELLER, constants.TYPES.BRAND];
var constants_1 = _objectSpread(_objectSpread({}, constants), {}, {
  HIDDEN_NODE_HEADER,
  MAX_L2,
  BUTTON_MOBILE_FOLLOWER
});
var constants$1 = /*@__PURE__*/getDefaultExportFromCjs(constants_1);
export { constants$1 as a, constants_1 as c };
